import {
  Context,
  PropsWithChildren,
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

export type TMessageDraftsContext = {
  messageDrafts: MessageDraftsType;
  onMessageDraftsChange: (
    channelUrl: string,
    id: string,
    draft: string,
  ) => void;
};

export const MessageDraftsContext: Context<TMessageDraftsContext> =
  createContext({
    messageDrafts: {},
    onMessageDraftsChange: () => {},
  });

export const MessageDraftsContextProvider = ({
  children,
}: PropsWithChildren) => {
  const [messageDrafts, setMessageDrafts] = useState<MessageDraftsType>({});

  const onMessageDraftsChange = useCallback(
    (channelUrl: string, id: string, draft: string): void => {
      setMessageDrafts((prev) => ({
        ...prev,
        [channelUrl]: {
          ...prev[channelUrl],
          [id]: draft,
        },
      }));
    },
    [],
  );

  return (
    <MessageDraftsContext.Provider
      value={{ messageDrafts, onMessageDraftsChange }}
    >
      {children}
    </MessageDraftsContext.Provider>
  );
};

export const useMessageDraftsContext = (): TMessageDraftsContext => {
  const context = useContext(MessageDraftsContext);
  if (!context) {
    throw new Error(
      'useMessageDraftsContext must be used within a MessageDraftsContextProvider.',
    );
  }
  return context;
};
